import React, { FunctionComponent, useMemo } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as IconCheck } from "../../../../icons/check.svg";
import { ReactComponent as IconTrash } from "../../../../icons/trash.svg";
import { ReactComponent as IconX } from "../../../../icons/x.svg";
import Button from "../../../atoms/Button";
import "./style.scss";

type ValidationType = "error" | "primary";

interface Props {
  feedback?: { label: string; alt?: string };
  onCancel: () => void;
  onValidate: () => void;
  validateButton?: { disabled: boolean; label: string; type: ValidationType };
}

const ValidationHeader: FunctionComponent<Props> = ({
  feedback,
  onCancel,
  onValidate,
  validateButton,
}) => {
  const intl = useIntl();

  const validationType: ValidationType = useMemo(
    () => (validateButton && validateButton.type) || "primary",
    [validateButton]
  );

  return (
    <div className="ValidationHeader">
      <Button onClick={onCancel} type="neutral">
        <IconX />
        <span className="ValidationHeader-button-text">
          {intl.formatMessage({ id: "kustom_ConfirmModal_cancel" })}
        </span>
      </Button>

      {feedback && (
        <div className="ValidationHeader-feedback" data-alt={feedback.label}>
          <span>{feedback.alt || feedback.label}</span>
        </div>
      )}

      <Button
        disabled={validateButton && validateButton.disabled === true}
        onClick={onValidate}
        type={validationType}
      >
        <span className="ValidationHeader-button-text">
          {(validateButton && validateButton.label) || intl.formatMessage({ id: "kustom_save" })}
        </span>
        {validationType === "error" ? <IconTrash /> : <IconCheck />}
      </Button>
    </div>
  );
};

export default ValidationHeader;
